interface GuideMessageProps {
	message: string;
}

const GuideMessage = ({ message }: GuideMessageProps) => {
	return <small className='text-gray-400 font-light italic'>{message}</small>;
};
export default GuideMessage;
